// @ts-nocheck

/**
 * Cordial back-in-stock subscription. Submit handling is delegated at the
 * document level so forms injected after page load (e.g. quick view modal
 * morph) are handled without a page reload. All lookups are scoped to the
 * submitted form, with a document-level fallback for the product attribute
 * div on standalone PDPs where it renders as a non-ancestor sibling.
 */
import { toString } from '@theme/object-util';

document.addEventListener('submit', (event) => {
  const form =
    event.target instanceof Element ? event.target.closest('form.cordial-bis-form') : null;
  if (!form) return;

  event.preventDefault();

  // Submit is delegated and preventDefault()'d, so the browser never runs its
  // native constraint validation. Trigger it manually and bail on an empty or
  // malformed email — otherwise a blank "Notify Me" click shows the success
  // toast and dispatches an empty-email subscribe event.
  const emailInput = form.querySelector('input[id^="cordial-bis-email"]');
  if (!emailInput || !emailInput.reportValidity()) return;

  const email = emailInput.value;
  const productElement =
    form.closest('[data-cnstrc-item-id]') ?? document.querySelector('div[data-cnstrc-item-id]');
  const product = getProductFromElement(productElement);

  document.dispatchEvent(
    new CustomEvent('cordial:event', {
      bubbles: true,
      cancelable: true,
      detail: {
        type: 'submit',
        action: 'subscribeBackInStock',
        properties: {
          email: email,
          product: product,
        },
      },
    })
  );

  const toast = form.closest('.cordial-bis')?.querySelector('.cordial-bis-toast');

  showCordialBisToast(toast, 'You’ll be notified when this item is back in stock!', 'success');
});

function getProductFromElement(element) {
  if (!element) return null;

  const productId = toString(element.getAttribute('data-product-id'));
  const variantId = toString(element.getAttribute('data-variant-id'));
  const parentSku = toString(element.getAttribute('data-cnstrc-item-id'));
  const sku = toString(element.getAttribute('data-cnstrc-item-variation-id'));
  const title = toString(element.getAttribute('data-cnstrc-item-name'));
  const price = toString(element.getAttribute('data-cnstrc-item-price'));

  return {
    productId: productId,
    variantId: variantId,
    sku: sku || parentSku,
    title: title,
    price: price,
  };
}

function showCordialBisToast(toast, message, type = 'success') {
  if (!toast) return;
  const toastIcon = toast.querySelector('svg use');
  const toastText = toast.querySelector('span');
  if (!toastText) return;
  toastText.textContent = message;

  toast.classList.remove('alert-success', 'alert-error');
  if (toastIcon) {
    if (type === 'success') {
      toastIcon.setAttribute('xlink:href', '#alert-success');
    } else {
      toastIcon.setAttribute('xlink:href', '#alert-error');
    }
  }

  if (type === 'success') {
    toast.classList.add('alert-success');
  } else {
    toast.classList.add('alert-error');
  }

  toast.style.display = '';
  toast.classList.remove('opacity-0');
  toast.classList.add('opacity-100');

  setTimeout(() => {
    toast.classList.remove('opacity-100');
    toast.classList.add('opacity-0');
    setTimeout(() => {
      toast.style.display = 'none';
    }, 300);
  }, 4000);
}
